module.exports = __webpack_public_path__ + "img/mobile_story.9973e323.svg";